import * as yup from 'yup';

export const CreateOrganisationValidationSchema = yup.object().shape({
    registrationName: yup.string().required('Registration name is required').max(128, 'Registration name must not exceed 128 characters'),
    tradeName: yup.string().max(128, 'Trade name must not exceed 128 characters').nullable(),
    registrationNumber: yup.string()
        .nullable()
        .transform((curr, orig) => (orig === '' ? null : curr))
        .max(15, 'Registration Number must be less than/equal to 15 Characters')
        .matches(/^(?:\d{4}\/\d{6}\/\d{2}|IT\d{4}\/\d{4}|\d{3}-\d{3}|\d{13})$/, 'Registration number must be in one of the following formats: xxxx/xxxxxx/xx or ID number: xxxxxxxxxxxxx or Trust Number: ITxxxx/xxxx or 6 Digit NPO number: xxx-xxx'),
    vatNumber: yup
        .string()
        .nullable()
        .transform((curr, orig) => (orig === '' ? null : curr))
        .max(10, 'VAT number must be less than/equal to 10 Characters')
        .matches(/^\d+$/, 'VAT number should have digits only')
});


